/**
 * Count the people actually signed up for a course: the course-level
 * `participants` array plus one `participants<N>` array per course date.
 *
 * Never read `course.totalSignups` for display. That counter is only
 * maintained by the self-signup routes; admin add/remove goes through the
 * generic PATCH route and leaves it untouched, so it drifts from the arrays
 * (dokkapk course 3 showed «1 påmeldt» with every participant list empty).
 *
 * @param {Object} course
 * @returns {number}
 */
export function countCourseSignups(course = {}) {
    if (!course || typeof course !== 'object') {
        return 0;
    }
    let total = Array.isArray(course.participants) ? course.participants.length : 0;
    const dates = Array.isArray(course.dates) ? course.dates : [];
    for (let i = 0; i < dates.length; i += 1) {
        const dateParticipants = course[`participants${i + 1}`];
        if (Array.isArray(dateParticipants)) {
            total += dateParticipants.length;
        }
    }
    return total;
}

/**
 * Distinct people on a course: the same user on several dates counts once.
 * Mirrors the backend's collectCourseParticipants() used by «Send exam».
 *
 * @param {Object} course
 * @returns {number}
 */
export function countUniqueCourseParticipants(course = {}) {
    if (!course || typeof course !== 'object') {
        return 0;
    }
    const seen = new Set();
    const add = list => (Array.isArray(list) ? list : []).forEach(p => {
        const id = p && typeof p === 'object' ? Number(p.id) : Number(p);
        if (id > 0) seen.add(id);
    });
    add(course.participants);
    for (let i = 1; i <= 50; i += 1) {
        add(course[`participants${i}`]);
    }
    return seen.size;
}

export default countCourseSignups;
